var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aphorism" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "prefix" }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.aphorismData.content))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "time" }, [
      _c("div", { staticClass: "title" }, [_vm._v("数据更新时间")]),
      _vm._v(" "),
      _c("div", { staticClass: "date" }, [
        _vm._v(_vm._s(_vm.aphorismData.createTime))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22fabb6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fabb6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mAphorism.vue
// module id = null
// module chunks = 